module.exports = __webpack_public_path__ + "img/logo.ecb7bddb.png";